// src/firebase.js
import { initializeApp } from "firebase/app";
import { getDatabase } from "firebase/database";
// analytics is optional — uncomment if you want analytics
// import { getAnalytics } from "firebase/analytics";

const firebaseConfig = {
  apiKey: "AIzaSyBA6DldIzk7-rNlqa4L09Bp5h0utlgOnNM",
  authDomain: "jauhari-8ea44.firebaseapp.com",
  databaseURL: "https://jauhari-8ea44-default-rtdb.asia-southeast1.firebasedatabase.app",
  projectId: "jauhari-8ea44",
  storageBucket: "jauhari-8ea44.firebasestorage.app",
  messagingSenderId: "258745599289",
  appId: "1:258745599289:web:d0219ea122c2cd5ce594e8",
  measurementId: "G-3FFX7DVMYW"
};

const app = initializeApp(firebaseConfig);
// const analytics = getAnalytics(app);
export const db = getDatabase(app);
export default app;
